module.exports = __webpack_public_path__ + "static/media/Manual-of-Hidro-CTRL.f6f69219.pdf";